import React from 'react';

import { acceptPrivacyPolicyChanges, retrievePrivacyPoliciesMissingConsent } from '../../utils/privacyApi';

import PrivacyChangeLightbox from './PrivacyChangeLightbox';

export default class PrivacyChangeSummary extends React.Component {
  state = {
    isLoaded: false,
    hasAccepted: false,
    privacyChanges: [],
  };

  componentDidMount() {
    retrievePrivacyPoliciesMissingConsent()
      .then((changes) => this.setState({
        privacyChanges: changes || [],
        isLoaded: true,
      }))
      .catch((err) => {
        this.setState({ isLoaded: true });
        console.error(err);
      });
  }

  hasNonAcceptedChanges = () => this.state.privacyChanges.length > 0;

  acceptChangesInPrivacy = () => {
    acceptPrivacyPolicyChanges()
      .then(() => this.setState({ hasAccepted: true }))
      .catch(console.error);
  };

  render() {
    if (!this.state.isLoaded || !this.hasNonAcceptedChanges() || this.state.hasAccepted) {
      return null;
    }

    return <PrivacyChangeLightbox
      privacyChanges={this.state.privacyChanges}
      onAccept={this.acceptChangesInPrivacy}
    />;
  }
}
